import {useMutation} from '@apollo/client/react';
import {Job} from '@cp/model';
import {CREATE_QUESTION_VALIDATION_GPT_JOB} from '../sharedQueries';

export function useCreateQuestionValidationGptJob() {
  const [createQuestionValidationGptJobMutation, {loading, error}] = useMutation<
    {createQuestionValidationGptJob: Job},
    {moduleId: string; topics?: string[]; difficulties?: number[]; runLimit?: number}
  >(CREATE_QUESTION_VALIDATION_GPT_JOB);

  /**
   * Create a question validation GPT job
   * @param moduleId - The module ID to validate questions for
   * @param topics - Optional array of topics to validate (if not provided, validates all topics)
   * @param difficulties - Optional array of difficulties to validate (if not provided, validates all difficulties)
   * @param runLimit - Optional limit on the number of questions to validate
   * @returns Job if successful, otherwise undefined
   */
  const createQuestionValidationGptJob = async (
    moduleId: string,
    topics?: string[],
    difficulties?: number[],
    runLimit?: number,
  ) => {
    const result = await createQuestionValidationGptJobMutation({
      variables: {moduleId, topics, difficulties, runLimit},
    });

    return result.data?.createQuestionValidationGptJob;
  };

  return {
    createQuestionValidationGptJob,
    loading,
    error,
  };
}
